import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import GrupoContext from "../../../context/grupo/grupoContext";
import AuthContext from "../../../context/autentication/authContext";
import SubGrupoContext from "../../../context/subgrupo/subgrupoContext";
import Fab from "@material-ui/core/Fab";
import clsx from "clsx";

import { Button } from "@material-ui/core";
import GrupoSelector from "./SelectorGrupos";
import SubGrupoSelector from "./SelectorSubGrupos";
import DispositivoContext from "../../../context/dispositivo/dispositivoContext";
import ValidationsContext from "../../../context/validations/validationsContext";
import Dialogs from "../../Dialog/Dialogs";

import FormControl from "@material-ui/core/FormControl";
import ShowResponse from "./ShowResponse";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import MapSelector from "./MapSelector";
import InputMask from "react-input-mask";
import { MdHelp, MdVisibility, MdVisibilityOff } from "react-icons/md";
import Popover from "@material-ui/core/Popover";
import { Select, MenuItem } from "@material-ui/core";
import MarcaContext from "../../../context/marca/marcaContext";
import ModeloContext from "../../../context/modelo/modeloContext";
import Scaner from "../NuevoDispositivo/Scaner";
import InputAdornment from "@material-ui/core/InputAdornment";
import Input from "@material-ui/core/Input";
import BotonLoading from "../../Buttons/BotonLoading";
import MensajeAlerta from "components/MensajeAlerta";
import AlertaContext from "context/alertas/alertaContext";
////////// estilos ///////////////

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
  popover: {
    pointerEvents: "none",
  },
  icono: {
    zIndex: 999,
    width: "99%",
    position: "absolute",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    top: "1.2em",
    right: "36em",
  },
  root: {
    minHeight: "75vh",
    width: "98%",
    marginRight: "5em",
    flexGrow: 1,
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    minHeight: "70vh",
    width: "98%",
    marginRight: "40%",
    flexGrow: 1,
  },
  text: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  form: {
    minHeight: "100%",
    width: "98%",
    flexGrow: 1,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: "red",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function CrearUsuario(props) {
  ////////// estilos ///////////////
  const classes = useStyles();

  ///////////////// variables ////////////////
  const validationsContext = useContext(ValidationsContext);
  const {
    validateForm,
    validateDispositivoNumeroSerie,
    validateDispositivoNombre,
    validateDispositivoCodigoVerificacion,
  } = validationsContext;

  const marcaContext = useContext(MarcaContext);
  const { marcas, obtenerMarcas, agregarMarca } = marcaContext;

  const modeloContext = useContext(ModeloContext);
  const { modelo, obtenerModelos, agregarModelo } = modeloContext;

  const authContext = useContext(AuthContext);
  const { autenticado, cliente, usuario } = authContext;

  const grupoContext = useContext(GrupoContext);
  const { mensaje, obtenerGrupos, clearErrorGrupo, clearOkGrupo } =
    grupoContext;

  const subgrupoContext = useContext(SubGrupoContext);
  const {
    mensaje: mensajeSub,
    subGrupos,
    obtenerSubGrupos,
    clearErrorSubGrupo,
    clearOkSubGrupo,
  } = subgrupoContext;

  const dispositivoContext = useContext(DispositivoContext);
  const {
    errorDispositivo,
    mensaje: mensajeDisp,
    actualizarDispositivo,
    obtenerDispositivos,
  } = dispositivoContext;

  const getParamet = () => {
    let link = window.location.pathname;
    let newLink = link.split(":");
    let idMostrar = newLink[1];
    return idMostrar;
  };

  const [state, setState] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const alertaContext = useContext(AlertaContext);
  const { alerta, mostrarAlerta } = alertaContext;
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const [grupoElegido, setGrupoElegido] = useState();
  const [subGrupoElegido, setSubGrupoElegido] = useState();
  const [callback, setCallback] = useState({ msg: "", request: "" });
  const clienteId = usuario.cliente.id;
  const [qrAppKey, setQrAppKey] = useState();
  const [qrNroSerie, setNroSerie] = useState();
  const [open2, setOpen] = React.useState(false);
  const [option, setOption] = useState("");
  const [grupos, setGrupos] = useState();
  //const clienteId = usuario.clienteRol[0].cliente.id

  const setDispositivo = (value) => {
    let valorActual = value.filter(
      (v) => v.id === props.data.id
    );
    if (valorActual) {
      setState({
        id: props.data.id,
        latitud: valorActual[0].latitud,
        longitud: valorActual[0].longitud,
        modelo: valorActual[0].modelo,
        nombre: valorActual[0].nombre,
        numeroSerie: valorActual[0].numeroSerie,
        subGrupo: valorActual[0].subgrupo.nombre,
        idSubGrupo: valorActual[0].subgrupo,
        grupo: valorActual[0].subgrupo.grupo.nombre,
        idGrupo: valorActual[0].subgrupo.grupo.id,
        topeInactividad: valorActual[0].topeInactividad,
        appKey: valorActual[0].appkey, 
        tipoDispositivo: valorActual[0].modelo.tipoDispositivo ? valorActual[0].modelo.tipoDispositivo : "",
        showPassword: false,
      });
    }
  };
  const handleChange = (prop) => (event) => {
    setState({ ...state, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setState({ ...state, showPassword: !state.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    if (mensaje) {
      mostrarAlerta(mensaje.msg, mensaje.categoria);
      // limpio el msj
      clearErrorGrupo();
      clearOkGrupo();
    }
    if (mensajeSub) {
      mostrarAlerta(mensajeSub.msg, mensajeSub.categoria);
      // limpio el msj
      clearErrorSubGrupo();
      clearOkSubGrupo();
    }
    // eslint-disable-next-line
  }, [mensaje, mensajeSub]);
  useEffect(() => {
    obtenerDispositivos(cliente).then((value) => setDispositivo(value));
    obtenerGrupos(clienteId).then((value) => setGrupos(value.grupos));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (grupos) {
      obtenerSubGrupos(grupos[0].id);
    }
    // eslint-disable-next-line
  }, [grupos]);
  useEffect(() => {
    if (qrAppKey || qrNroSerie) {
      setState({
        ...state,
        appKey: qrAppKey,
        numeroSerie: qrNroSerie,
      });
    }
    // eslint-disable-next-line
  }, [qrAppKey, qrNroSerie]);
  ///////////////////////////////////////////
  ////////// funciones ///////////////

  const getSubG = (x) => {
    setCallback({ msg: "", request: "" });
    if (x) {
      setSubGrupoElegido("");
      obtenerSubGrupos(x);
    }
  };

  const [errors, setErrors] = useState({
    marca: "",
    modelo: "",
    numeroSerie: "",
    nombre: "",
    appKey: "",
  });
  const onChange = (e) => {
    setCallback({ msg: "", request: "" });
    if (e.target.name === "numeroSerie" || e.target.name === "appKey") {
      setState({
        ...state,
        [e.target.name]: e.target.value.replace(/ /g, ""),
      });
    } else {
      setState({
        ...state,
        [e.target.name]: e.target.value,
      });
    }
    switch (e.target.name) {
      case "marca":
        setErrors({
          ...errors,
          marca: validateDispositivoNombre(e.target.value),
        });
        break;
      case "modelo":
        setErrors({
          ...errors,
          modelo: validateDispositivoNombre(e.target.value),
        });
        break;
      case "numeroSerie":
        setErrors({
          ...errors,
          numeroSerie: validateDispositivoNumeroSerie(
            e.target.value.replace(/ /g, "")
          ),
        });
        break;
      case "nombre":
        setErrors({
          ...errors,
          nombre: validateDispositivoNombre(e.target.value),
        });
        break;
      case "appKey":
        setErrors({
          ...errors,
          appKey: validateDispositivoCodigoVerificacion(
            e.target.value.replace(/ /g, "")
          ),
        });
        break;
    }
  };

  const onSubmit = () => {
    if (autenticado) {
      obtenerGrupos(clienteId);
    }
    let toSave;
    // Validar que no haya campos vacios
    if (!validateForm(errors)) {
      setCallback({
        ...callback,
        msg: "*todos los campos son obligatorios",
      });
    } else {
      let subG = subGrupoElegido ? subGrupoElegido : state.idSubGrupo;
      subG.grupo = grupoElegido ? grupoElegido : state.idGrupo;
      setCallback({
        ...callback,
        msg: "",
      });
      toSave = {
        id: "" || props.data.id,
        modeloId: "" || state.modelo.id,
        numeroSerie: "" || state.numeroSerie.toLowerCase(),
        nombre: "" || state.nombre,
        clienteId: "" || cliente,
        subgrupoId: "" || subG.id,
        appkey: "" || state.appKey.toLowerCase(),
        latitud: "" || state.latitud,
        longitud: "" || state.longitud,
        topeInactividad: ""|| state.topeInactividad,
        usuarios: "" || [usuario.id],
      };
    }
    actualizarDispositivo(toSave).then((value) => setCallback(value));
    obtenerGrupos(clienteId);
    props.refreshUs();
    props.refreshUs();
    setTimeout(props.setOpen(false), 1000);
  };
  const history = useHistory();
  const link = () => {
    history.push("/dispositivos");
  };
  const setAdd = (x) => {
    setOpen(true);
    setOption(x);
  };
  const handleCloseGrupo = () => {
    obtenerGrupos(clienteId).then((value) => setGrupos(value.grupos));
    setOpen(false);
  };
  const handleCloseSubGrupo = () => {
    getSubG(grupoElegido.id);
    setOpen(false);
  };
  const init = () => {
    restartSubgrupo();
    setGrupoElegido();
    obtenerGrupos(clienteId).then((value) => setGrupos(value.grupos));
  };
  const restartSubgrupo = () => {
    setSubGrupoElegido();
  };
  const initS = () => {
    restartSubgrupo();
    obtenerGrupos(clienteId).then((value) => setGrupos(value.grupos));
  };
  function selectCoordinate(x) {
    navigator.geolocation.getCurrentPosition(function (position) {
      setState({
        ...state,
        latitud: x.lat,
        longitud: x.lng,
      });
    });
  }
  return (
    <div style={{ width: "1000px", position: "relative" }}>
      {alerta ? (
        <MensajeAlerta categoria={alerta.categoria} mensaje={alerta.msg} />
      ) : null}
      <div className={classes.icono}>
        <Typography
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <Paper style={{ padding: "7px" }}>
            <MdHelp
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          </Paper>
        </Typography>
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper2,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography>
            Haga doble click en el mapa para seleccionar la ubicación del
            dispositivo
          </Typography>
        </Popover>
      </div>
      <div noValidate autoComplete="off" onSubmit={onSubmit}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={1}
        >
          {state ? (
            <>
              <Grid item xs={7} style={{ height: "500px" }}>
                {/* {state.modelo !== "GPS" && */}
                <Grid
                  item
                  xs={12}
                  style={{ height: "98%", width: "98%", padding: "0px" }}
                >
                  {state.latitud && (
                    <MapSelector
                      zoom={13}
                      selected={{ lat: state.latitud, lng: state.longitud }}
                      center={{
                        lat: -33.123784899551374,
                        lng: -64.34898889983391,
                      }}
                      select={selectCoordinate}
                    />
                  )}
                </Grid>
                {/* } */}
              </Grid>
              <Grid item xs={5}>
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid items xs={12} style={{textAlign:"left", fontSize: "18px"}}>
                      <br/> 
                      1. Seleccione el dispositivo
                  </Grid>
                  <Grid item xs={6}>
                    <Grid item xs={12}>
                      <TextField
                        disabled
                        margin="normal"
                        required
                        fullWidth
                        name="Marca"
                        label={"Marca"}
                        style={{margin:"5px"}}
                        value={
                          state.modelo
                            ? state.modelo.marca.nombre
                            : "MarcaElegida"
                        }
                        defaultValue={
                          state.modelo
                            ? state.modelo.marca.nombre
                            : "MarcaElegida"
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      disabled
                      margin="normal"
                      required
                      fullWidth
                      name="Modelo"
                      label={"Modelo"}
                      style={{margin:"5px"}}
                      value={
                        state.modelo ? state.modelo.nombre : "ModeloElegido"
                      }
                      defaultValue={
                        state.modelo ? state.modelo.nombre : "ModeloElegido"
                      }
                    />
                  </Grid>
                  <Grid items xs={12} style={{textAlign:"left", fontSize: "18px"}}>
                    2. Datos de registro
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      disabled
                      margin="normal"
                      required
                      fullWidth
                      name="numeroSerie"
                      label={"DevEUI"}
                      style={{margin:"5px"}}
                      value={state.numeroSerie}
                      defaultValue={state.numeroSerie + " "}
                    />
                  </Grid>
                  {state.modelo ? (
                    state.modelo.marca.nombre === "Agrolink" ||
                    state.modelo.marca.nombre === "AgroLink"  ||
                    state.modelo.QR ? (
                      <>
                        <Grid item xs={11}>
                          <TextField
                            error={errors.nombre.length > 0}
                            margin="normal"
                            required
                            fullWidth
                            name="nombre"
                            style={{margin:"5px"}}
                            label={
                              errors.nombre.length > 0
                                ? errors.nombre
                                : "Nombre"
                            }
                            value={state.nombre}
                            defaultValue={state.nombre + " "}
                            onChange={onChange}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <Scaner appKey={setQrAppKey} />
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item xs={12}>
                          <TextField
                            error={errors.nombre.length > 0}
                            margin="normal"
                            required
                            fullWidth
                            name="nombre"
                            style={{margin:"5px"}}
                            label={
                              errors.nombre.length > 0
                                ? errors.nombre
                                : "Nombre"
                            }
                            value={state.nombre}
                            defaultValue={state.nombre + " "}
                            onChange={onChange}
                          />
                        </Grid>
                      </>
                    )
                  ) : null}
                  {state.tipoDispositivo!== "FIELD" &&
                    <Grid item xs={12}>
                      <FormControl
                        className={clsx(classes.margin, classes.textField)}
                        style={{ width: "100%", margin:"5px" }}
                      >
                        <InputMask
                          mask="** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ ** \ **"
                          value={state.appKey}
                          onChange={onChange}
                          /* defaultValue={state.appKey + " "} */
                        >
                          {() => (
                            <Input
                              error={errors.appKey.length > 0}
                              margin="normal"
                              required
                              fullWidth
                              name="appKey"
                              value={state.appKey}
                              defaultValue={state.appKey + " "}
                              label={
                                errors.appKey.length > 0
                                  ? errors.appKey
                                  : "AppKey"
                              }
                              type={state.showPassword ? "text" : "password"}
                              id="adornment-password"
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {state.showPassword ? (
                                      <MdVisibility />
                                    ) : (
                                      <MdVisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          )}
                        </InputMask>
                      </FormControl>
                    </Grid>
                  }
                  <Grid item xs={6}>
                    {grupos && (
                      <GrupoSelector
                        elegido={grupoElegido}
                        actual={state.grupo}
                        grupos={grupos}
                        func={setGrupoElegido}
                        subG={getSubG}
                        setAdd={setAdd}
                      />
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <SubGrupoSelector
                      idActual={state.idGrupo}
                      actual={state.subGrupo}
                      grupos={subGrupos}
                      elegido={grupoElegido}
                      subGrupos={subGrupos}
                      func={setSubGrupoElegido}
                      setAdd={setAdd}
                    />
                  </Grid>
                  <Grid item xs={12}>
                  <Grid container direction="column" alignItems="flex-end">
                      <Grid item xs={6} style={{marginTop:"15px"}}>
                        {validateForm(errors) ? (
                          <BotonLoading
                            texto={"Guardar"}
                            disabled={false}
                            load={callback}
                            onClick={onSubmit}
                          />
                        ) : (
                          <BotonLoading
                            texto={"Guardar"}
                            disabled={true}
                            load={callback}
                            onClick={onSubmit}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  style={{ height: "3em" }}
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  spacing={3}
                ></Grid>
              </Grid>
            </>
          ) : null}
        </Grid>
      </div>
      {option === "addgrupo" && (
        <Dialogs
          open={open2}
          handleClose={handleCloseGrupo}
          titulo={"Nuevo Grupo"}
          option={"nuevoGrupo"}
          init={init}
          setOpen={setOpen}
          clienteID={clienteId}
          alerta={alerta}
        />
      )}
      {option === "addsubgrupo" && (
        <Dialogs
          open={open2}
          handleClose={handleCloseSubGrupo}
          titulo={"Nuevo Subgrupo"}
          option={"nuevoSubgrupo"}
          inits={initS}
          setOpen={setOpen}
          clienteID={clienteId}
          grupo={grupoElegido}
          alerta={alerta}
        />
      )}
    </div>
  );
}
